import { render } from "./StepTwo.vue?vue&type=template&id=b1c19aee&scoped=true"
import script from "./StepTwo.vue?vue&type=script&lang=js"
export * from "./StepTwo.vue?vue&type=script&lang=js"

import "./StepTwo.vue?vue&type=style&index=0&id=b1c19aee&scoped=true&lang=css"

import exportComponent from "/var/www/extranet-sinistre/production/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1c19aee"]])

export default __exports__